<template>
  <!--o-section :title="label || schema.verbose_name" not-closable :level="level"-->
  <o-repeating-cards
    :list="filteredItems"
    @change="changed"
    :default-new-value="newChild"
    :form-state="formState"
    :item-name="schema.verbose_name"
    :disable-actions="true"
    :disable-add="true"
    v-if="filteredItems.length > 0"
  >
    <template slot-scope="props">
      <item-form
        :item="filteredItems[props.index]"
        :server-errors="_se[props.index]"
        :form-state="formState"
        :level="level"
        @approved="approved"
        @rejected="rejected"
        @pending="pending"
      ></item-form>
    </template>
  </o-repeating-cards>
  <!--/o-section-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";

import OSection from "../../../vue-ocom/components/layout/OSection";
import ORepeatingCards from "../../../vue-ocom/components/table/ORepeatingCards";
import UserMixin from "../../mixins/UserMixin";

import ItemForm from "./ItemForm";
import * as LEAVE_TASK_TYPES from "../../leave_task_types.js";
import * as LEAVE_TASK_STATUS from "../../leave_task_status.js";
import { LTA_NEW } from "@/app/leave_task_actions.js";
export default {
  name: "LeaveRequestTaskFormCards",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("LeaveRequestTask"),
    CreateCodeTableFetchMixin(["Employee"]),
    UserMixin,
  ],
  components: { OSection, ORepeatingCards, ItemForm },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
    cancel: { type: Boolean, default: false },
    isCurrentuserOwner: { type: Boolean, default: false },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.LeaveRequestTask,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.LeaveRequestTask),
    };
  },
  methods: {
    cancelled(item) {
      if (this.cancel) {
        // Employee just cancelled so add a Cancel Approval Task
        this.items.push({
          ...CreateDefaultItem(schema.LeaveRequestTask),
          task_type: LEAVE_TASK_TYPES.CANCEL_APPROVAL,
          action: LTA_NEW, // New
        });
      } else {
        // Remove Cancel Approval Task
        let cancel_task_index = this.items.findIndex(
          (task) => task.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL
        );

        if (cancel_task_index !== -1) {
          // Remove the cancel task from the list of tasks
          this.items.splice(cancel_task_index, 1);
        }
      }

      this.changed();
    },
    approved(item) {
      if (this.items.length === 1) {
        // Manager just approved so add a Payroll Approval Task
        this.items.push({
          ...CreateDefaultItem(schema.LeaveRequestTask),
          task_type: LEAVE_TASK_TYPES.PAYROLL_APPROVAL,
          action: LTA_NEW, // New
        });

        this.changed();
      }
    },
    removeOtherTasks(item) {
      var index = _.indexOf(this.items, item);

      this.items = this.items.splice(0, index + 1); // remove other Tasks after this.
      this.changed();
    },
    rejected(item) {
      this.removeOtherTasks(item);
    },
    pending(item) {
      this.removeOtherTasks(item);
    },
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {
    ...mapGetters("AuthModule", ["currentUser"]),
    filteredItems() {
      if (this.items) {
        let manager_approval_task = this.items.find(
          (task) => task.task_type === LEAVE_TASK_TYPES.MANAGER_APPROVAL
        );
        let payroll_approval_task = this.items.find(
          (task) => task.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL
        );
        let cancel_approval_task = this.items.find(
          (task) => task.task_type === LEAVE_TASK_TYPES.CANCEL_APPROVAL
        );

        if (this.isManager) {
          // If current user is owner & also a manager, remove everything
          if (this.isCurrentuserOwner) return [];
          // Remove payroll_approval_task
          return this.items.filter(
            (task) => task.task_type !== LEAVE_TASK_TYPES.PAYROLL_APPROVAL
          );
        }

        if (this.isPayroll) {
          // If current user is owner & also a payroll, remove everything
          if (this.isCurrentuserOwner) return [];

          // If leave request is not cancelled, show the payroll approval task
          if (!cancel_approval_task)
            return this.items.filter(
              (task) => task.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL
            );

          // If leave request cancellation was rejected by manager, show the payroll approval task
          if (cancel_approval_task) {
            if (cancel_approval_task["status"] === LEAVE_TASK_STATUS.REJECTED)
              return this.items.filter(
                (task) => task.task_type === LEAVE_TASK_TYPES.PAYROLL_APPROVAL
              );
          }

          // Else, don't show anything
          else return [];
        }

        // Add more conditions here if necessary

        // Else, show all tasks
        return this.items;
      }
    },
  },
  created() {
    // this.loadCodeTables()
  },
  watch: {
    cancel: function () {
      this.cancelled();
    },
  },
};
</script>
